import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "M18.359 20.113h-1.08v-1.936c0-1.96-1.076-3.76-3.028-5.071-.243-.163-.394-.515-.394-.919s.151-.756.394-.919c1.952-1.31 3.027-3.111 3.027-5.07V4.26h1.08a.63.63 0 0 0 0-1.261H5.686a.63.63 0 1 0 0 1.26h1.08v1.937c0 1.96 1.075 3.76 3.028 5.071.243.163.393.515.393.92 0 .403-.15.755-.393.918-1.953 1.31-3.028 3.112-3.028 5.071v1.936h-1.08a.63.63 0 0 0 0 1.261h12.674a.63.63 0 1 0 0-1.26M8.026 18.177c0-2.059 1.547-3.405 2.47-4.024.595-.4.951-1.135.951-1.966 0-.83-.356-1.566-.951-1.966-.923-.619-2.47-1.965-2.47-4.024V4.261h7.991v1.936c0 2.06-1.547 3.405-2.469 4.024-.596.4-.952 1.135-.952 1.966s.356 1.566.952 1.966c.922.62 2.47 1.965 2.47 4.024v1.936H8.025z"
    }, null, -1)
  ]))]))
}
export default { render: render }